import { useContext, useRef, useState } from "react";
import AppInfoContext from 'src/provider/state-manager/appInfoProvider'
import { 
    AbsoluteContainer,
    AppLabel,
    AppSpan, AppText, Button, CenterPopupContainer, CustomContainer, 
    FixedContainer, 
    FlexColumn, FlexRow, GridContainer, ScreenTitle 
} from "src/style"
import { NewSubsidiaryLayout } from 'src/component';
import helpers from "src/utils/helpers";
import UploadIcon from 'src/assets/svg/upload-icon'
import { RiDeleteBinLine } from "react-icons/ri"
import PicIcon from 'src/assets/svg/pics-icon'
import { useNotifier } from "react-pop-notifier"

export const NewSubsidiaryDocs: React.FC<any> = ({formData, setFormData, next, back, close}) => {
    const {notifier} = useNotifier()
    const {info: {subsidiaryCreationProcess}, setInfoProperty} = useContext(AppInfoContext)
    const [isHover, setIsHover] = useState(false)

    const idImageRef = useRef<any>(null);

    async function handleFile (e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files instanceof FileList) {
            if(!helpers.isValidFileType(e.target.value)) {
                setFormData({...formData, document: ''})
                return notifier.show('Only PNG, JPG, and JPEG files are allowed', 'Validation Error')
            }
            setFormData({...formData, document: e.target.files[0]})
        }
    }

    async function handleSubmit() {
        await setInfoProperty('subsidiaryCreationProcess', {...subsidiaryCreationProcess, documents: true})
        
        next()
        close()
    }
    
    return (
        <>
            <CenterPopupContainer onClick={close} />
            <FixedContainer
                top="50" tSizeUnit="%" 
                left="50" lSizeUnit="%"
                bgColor="#ffffff" zIndex='9'
                height='82.6' width='123.6'
                radius='0.8'
                className="popup-container-lg"
            >
                <NewSubsidiaryLayout currentScreen='details'>
                    <CustomContainer bottomMargin="2.5">
                        <ScreenTitle 
                            textSize="2" color="#111111" 
                            fontWeight="600"
                        >
                            Subsidiary business document
                        </ScreenTitle>
                        <AppSpan textSize="1.6" color="#4F4F4F">
                            Orci, porttitor feugiat sociis quis pellentesque non morbi. 
                            Ultricies mi dignissim lorem in. Vitae aliquet gravida sed massa dolor.
                        </AppSpan>
                    </CustomContainer>
                    
                    <CustomContainer topMargin="7">
                        { !formData.document ?
                            <FlexColumn 
                                radius='0.8' minHeight='26.4'
                                padding='1.5'
                                className='doc-upload-container'
                                onClick={() => idImageRef.current.click()}
                                onMouseEnter={() => setIsHover(true)}
                                onMouseLeave={() => setIsHover(false)}
                            >
                                <UploadIcon isHover={isHover} className='icon-component' />
                                <input 
                                    type="file" name='img1' 
                                    onChange={handleFile} 
                                    ref={idImageRef} 
                                    className='file-input'
                                    id="doc" 
                                />
                                <AppText topMargin='1' align="center">Click to upload your business document</AppText>
                                <AppSpan color="#BDBDBD" textSize="1.2">Supports png, jpg, pdf</AppSpan>
                            </FlexColumn>
                            :
                            <GridContainer 
                                borderColor='#5627FF' radius='0.8' minHeight='9.6'
                                padding='1' topMargin='2'
                            >
                                <FlexRow alignItems='flex-start'>
                                    <AbsoluteContainer top='0' right='0' zIndex="2">
                                        <AppSpan 
                                            textSize='1.8' color='#667085' hoverColor='#F80000' cursor='pointer'
                                            onClick={() => setFormData({...formData, document: ''})}
                                        >
                                            <RiDeleteBinLine />
                                        </AppSpan>
                                    </AbsoluteContainer>
                                    <PicIcon 
                                        className='icon-component' 
                                        style={{flexBasis: 'auto', flexShrink: '0', flexGrow: '0'}} 
                                    />
                                    <CustomContainer leftMargin='1.5'>
                                        <AppLabel color='#344054' fontWeight='600'>{formData.document?.name}</AppLabel>
                                        <AppText color='#667085' topMargin='-0.7' >{(formData.document?.size / 1024).toFixed(1)} KB</AppText>
                                        <FlexRow gap='1'>
                                            <CustomContainer 
                                                width='85' height='0.8' sizeUnit='%' 
                                                bgColor='#EAECF0' radius='0.4' overflow='hidden' 
                                            >
                                                <CustomContainer bgColor='#5627FF' height='0.8' radius='0.4' width='100' sizeUnit='%'/>
                                            </CustomContainer>
                                            <AppSpan color='#344054' fontWeight='600'>100%</AppSpan>
                                        </FlexRow>
                                    </CustomContainer>
                                </FlexRow>
                            </GridContainer>
                        }
                        {/* <AppText 
                            textSize='1.6' color='#5627FF' 
                            fontWeight='700' topMargin='3'
                            hoverColor='#828282' cursor='pointer'
                        >
                            Upload another business document
                        </AppText> */}

                        <FlexRow 
                            justifyContent='flex-end'
                            topMargin='5' gap="1"
                        >
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff'
                                bgColor="#ffffff" 
                                hoverBorderColor='#5627FF'
                                hoverColor='#5627FF'
                                color="#5627FF"
                                onClick={back}
                            >
                                Back
                            </Button>
                            <Button 
                                width='15.4' 
                                hoverBgColor='#ffffff' 
                                hoverColor='#5627FF'
                                borderColor='#5627FF'
                                onClick={handleSubmit}
                            >
                                Submit
                            </Button>
                        </FlexRow>
                    </CustomContainer>
                </NewSubsidiaryLayout>
            </FixedContainer>
        </>
    )
}
